import { AlertType } from 'store/register/types';
import { RegistrationStatuses, SelectItem, ErrorStatusCodes } from './types';

// calling formatAlert without any args sets all to values to undefined,
// effectively removing the alert box from the UI
export const formatAlert = (severity?: AlertType, title?: string, message?: string) => ({
  severity,
  title,
  message
});

export const errorStatusCodes: ErrorStatusCodes = {
  DUPLICATE_USERNAME: 'MYH011',
  DUPLICATE_ACCOUNT: 'MYH006'
};

export const registrationStatuses: RegistrationStatuses = {
  ACCOUNT_INFO: 'AccountInformation',
  SELECT_HEALTH: 'SelectHealthRegistration',
  ACCOUNT_VERIFICATION: 'AccountVerification',
  ID_REG: 'IdentificationRegistration'
};

export const genders: SelectItem[] = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
  { value: 'prefer not to respond', label: 'Prefer not to respond' }
];

export const races: SelectItem[] = [
  { value: 'American Indian or Alaska Native', label: 'American Indian or Alaska Native' },
  { value: 'Asian', label: 'Asian' },
  { value: 'Black or African American', label: 'Black or African American' },
  { value: 'Native Hawaiian or Pacific Islander', label: 'Native Hawaiian or Pacific Islander' },
  { value: 'White', label: 'White' },
  { value: 'prefer not to respond', label: 'Prefer not to respond' }
];

export enum Step {
  INSURANCE = 'insurance',
  PERSONAL = 'personal',
  PERSONAL_REVIEW = 'personal-review',
  PERSONAL_ABRIDGED = 'personal-abridged',
  VERIFY_EMAIL = 'verify-email',
  VERIFY_PHONE = 'verify-phone',
  ACCOUNT = 'account',
  ERROR = 'error',
  SUCCESS = 'success'
}

export const stepProgress: Record<Step, number> = {
  [Step.INSURANCE]: 1,
  [Step.PERSONAL]: 2,
  [Step.PERSONAL_REVIEW]: 2,
  [Step.PERSONAL_ABRIDGED]: 2,
  [Step.VERIFY_EMAIL]: 3,
  [Step.VERIFY_PHONE]: 3,
  [Step.ACCOUNT]: 4,
  [Step.ERROR]: 5,
  [Step.SUCCESS]: 5
};

export const fields = [
  'firstName',
  'lastName',
  'dateOfBirth',
  'gender',
  'ethnicity',
  'streetAddress',
  'unitNumber',
  'city',
  'state',
  'zip',
  'country',
  'email',
  'phone'
];
